import type { TFunction } from 'i18next';

/**
 * Translate an enum value using i18n.
 *
 * Lookup order:
 *   1. `enums.<enumName>.<value>`
 *
 * Falls back to the raw value if no translation is found.
 *
 * @example
 *   tEnum(t, 'roomAdStatus', 'DRAFT')     → t('enums.roomAdStatus.DRAFT')
 *   tEnum(t, 'gender', 'MALE')            → t('enums.gender.MALE')
 */
export function tEnum(t: TFunction, enumName: string, value: string | null | undefined): string {
  if (!value) return '—';
  const key = `enums.${enumName}.${value}`;
  const translated = t(key, { defaultValue: '' });
  return translated || humanizeEnumValue(value);
}

export function humanizeEnumValue(value: string | null | undefined): string {
  if (!value) return '—';
  return String(value)
    .toLowerCase()
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
